<template>
  <div
    class="flex flex-col space-y-5 lg:items-center lg:flex-row lg:space-y-0 lg:space-x-3"
  >
    <div class="lg:w-52">
      <v-select
        v-model="value.min"
        :options="options"
        :placeholder="locales[lang].min_price"
        :filterable="false"
        :searchable="false"
        @input="edited"
      >
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes">
            <i class="text-gray-400 fal fa-chevron-down" />
          </span>
        </template>
      </v-select>
    </div>
    <p class="hidden mx-5 mt-4 text-sm tracking-wider uppercase lg:block">
      {{ locales[lang].to }}
    </p>
    <div class="lg:w-52">
      <v-select
        v-model="value.max"
        :options="options"
        :placeholder="locales[lang].max_price"
        :filterable="false"
        :searchable="false"
        @input="edited"
      >
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes">
            <i class="text-gray-400 fal fa-chevron-down" />
          </span>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import bus from "../js/bus.js";

export default {
  props: ["lang", "locales", "type"],
  data() {
    return {
      value: {
        min: "",
        max: "",
      },
      options: [
        {
          label: `€ ${this.$formatNumber(0, "DOT")}`,
          value: "",
        },
        {
          label: `€ ${this.$formatNumber(25000, "DOT")}`,
          value: 25000,
        },
        {
          label: `€ ${this.$formatNumber(50000, "DOT")}`,
          value: 50000,
        },
        {
          label: `€ ${this.$formatNumber(75000, "DOT")}`,
          value: 75000,
        },
        {
          label: `€ ${this.$formatNumber(100000, "DOT")}`,
          value: 100000,
        },
        {
          label: `€ ${this.$formatNumber(125000, "DOT")}`,
          value: 125000,
        },
        {
          label: `€ ${this.$formatNumber(150000, "DOT")}`,
          value: 150000,
        },
        {
          label: `€ ${this.$formatNumber(175000, "DOT")}`,
          value: 175000,
        },
        {
          label: `€ ${this.$formatNumber(200000, "DOT")}`,
          value: 200000,
        },
        {
          label: `€ ${this.$formatNumber(225000, "DOT")}`,
          value: 225000,
        },
        {
          label: `€ ${this.$formatNumber(250000, "DOT")}`,
          value: 250000,
        },
        {
          label: `€ ${this.$formatNumber(275000, "DOT")}`,
          value: 275000,
        },
        {
          label: `€ ${this.$formatNumber(300000, "DOT")}`,
          value: 300000,
        },
        {
          label: `€ ${this.$formatNumber(325000, "DOT")}`,
          value: 325000,
        },
        {
          label: `€ ${this.$formatNumber(350000, "DOT")}`,
          value: 350000,
        },
        {
          label: `€ ${this.$formatNumber(375000, "DOT")}`,
          value: 375000,
        },
        {
          label: `€ ${this.$formatNumber(400000, "DOT")}`,
          value: 400000,
        },
        {
          label: `€ ${this.$formatNumber(425000, "DOT")}`,
          value: 425000,
        },
        {
          label: `€ ${this.$formatNumber(450000, "DOT")}`,
          value: 450000,
        },
        {
          label: `€ ${this.$formatNumber(475000, "DOT")}`,
          value: 475000,
        },
        {
          label: `€ ${this.$formatNumber(500000, "DOT")}`,
          value: 500000,
        },
        {
          label: `€ ${this.$formatNumber(525000, "DOT")}`,
          value: 525000,
        },
        {
          label: `€ ${this.$formatNumber(550000, "DOT")}`,
          value: 550000,
        },
        {
          label: `€ ${this.$formatNumber(575000, "DOT")}`,
          value: 575000,
        },
        {
          label: `€ ${this.$formatNumber(600000, "DOT")}`,
          value: 600000,
        },
        {
          label: `€ ${this.$formatNumber(625000, "DOT")}`,
          value: 625000,
        },
        {
          label: `€ ${this.$formatNumber(650000, "DOT")}`,
          value: 650000,
        },
        {
          label: `€ ${this.$formatNumber(675000, "DOT")}`,
          value: 675000,
        },
        {
          label: `€ ${this.$formatNumber(700000, "DOT")}`,
          value: 700000,
        },
        {
          label: `€ ${this.$formatNumber(725000, "DOT")}`,
          value: 725000,
        },
        {
          label: `€ ${this.$formatNumber(750000, "DOT")}`,
          value: 750000,
        },
        {
          label: `€ ${this.$formatNumber(775000, "DOT")}`,
          value: 775000,
        },
        {
          label: `€ ${this.$formatNumber(800000, "DOT")}`,
          value: 800000,
        },
        {
          label: `€ ${this.$formatNumber(825000, "DOT")}`,
          value: 825000,
        },
        {
          label: `€ ${this.$formatNumber(850000, "DOT")}`,
          value: 850000,
        },
        {
          label: `€ ${this.$formatNumber(875000, "DOT")}`,
          value: 875000,
        },
        {
          label: `€ ${this.$formatNumber(900000, "DOT")}`,
          value: 900000,
        },
        {
          label: `€ ${this.$formatNumber(925000, "DOT")}`,
          value: 925000,
        },
        {
          label: `€ ${this.$formatNumber(950000, "DOT")}`,
          value: 950000,
        },
        {
          label: `€ ${this.$formatNumber(975000, "DOT")}`,
          value: 975000,
        },
        {
          label: `€ ${this.$formatNumber(1000000, "DOT")}`,
          value: 1000000,
        },
        {
          label: `€ ${this.$formatNumber(1500000, "DOT")}`,
          value: 1500000,
        },
        {
          label: `€ ${this.$formatNumber(2000000, "DOT")}`,
          value: 2000000,
        },
        {
          label: `€ ${this.$formatNumber(10000000, "DOT")}`,
          value: 10000000,
        },
        {
          label: `€ ${this.$formatNumber(100000000, "DOT")}`,
          value: 100000000,
        },
      ],
    };
  },
  mounted() {
    if (this.type === "let") {
      // Append 500 and 1000 to the options array on the second position
      this.options.splice(1, 0, {
        label: `€ ${this.$formatNumber(500, "DOT")}`,
        value: 500,
      });

      this.options.splice(2, 0, {
        label: `€ ${this.$formatNumber(1000, "DOT")}`,
        value: 1000,
      });
    }

    bus.$on("updateData", (item) => {
      // Min
      if (item.id === "min_price" && item.data) {
        this.value.min = {
          label: `€ ${this.$formatNumber(item.data, "DOT")}`,
          value: item.data,
        };
      } else if (item.id === "min_price" && !item.data) {
        this.value.min = "";
      }

      // Max
      if (item.id === "max_price" && item.data) {
        this.value.max = {
          label: `€ ${this.$formatNumber(item.data, "DOT")}`,
          value: item.data,
        };
      } else if (item.id === "max_price" && !item.data) {
        this.value.max = "";
      }
    });
  },
  methods: {
    edited() {
      let min = "";
      let max = "";

      if (this.value.min) {
        min = this.value.min.value;
      }

      if (this.value.max) {
        max = this.value.max.value;
      }

      bus.$emit("setData", {
        id: "min_max_price",
        data: {
          min,
          max,
        },
      });
    },
  },
};
</script>

